/*
 * @Author: WLL
 * @Date: 2020-04-13 15:06:55
 * @LastEditors: WLL
 * @LastEditTime: 2020-04-20 12:27:39
 * @Description: 路由
 */
import Vue from "vue";
import VueRouter from "vue-router";
import DemoComponents from "sj_components/src/views/DemoComponents";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "home"
  },
  {
    path: "/auth",
    name: "auth",
    component: () => import(/* webpackChunkName: "home" */ "@/views/Auth")
  },
  {
    path: "/no-auth",
    name: "no-auth",
    component: () => import(/* webpackChunkName: "home" */ "@/views/NoAuth"),
    meta: {
      title: "未登录"
    }
  },
  {
    path: "/home",
    name: "home",
    component: () => import(/* webpackChunkName: "home" */ "@/views/Home"),
    meta: {
      title: "金榜首页"
    }
  },
  {
    path: "/organization",
    name: "organization",
    component: () =>
      import(/* webpackChunkName: "organization" */ "@/views/Organization"),
    meta: {
      title: "机构预测排行"
    }
  },
  {
    path: "/analyst",
    name: "analyst",
    component: () =>
      import(/* webpackChunkName: "analyst" */ "@/views/Analyst"),
    meta: {
      title: "分析师预测排行"
    }
  },
  {
    path: "/industry",
    name: "industry",
    component: () =>
      import(/* webpackChunkName: "industry" */ "@/views/Industry"),
    meta: {
      title: "机构关注行业"
    }
  },
  {
    path: "/stock",
    name: "stock",
    component: () => import(/* webpackChunkName: "stock" */ "@/views/Stock"),
    meta: {
      title: "个股盈利预测"
    }
  },
  {
    path: "/reportDetail",
    name: "reportDetail",
    component: () =>
      import(/* webpackChunkName: "reportDetail" */ "@/views/ReportDetail"),
    meta: {
      title: "研报详情"
    }
  }
];

if (process.env.NODE_ENV === "development") {
  routes.push({
    path: "/components",
    name: "components",
    component: () => import("sj_components/src/views/Demo"),
    redirect: `/components/${DemoComponents[0].name}`,
    children: DemoComponents
  });
}
const router = new VueRouter({
  routes
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  const query = Object.assign({}, to.query, from.query);
  let resetRouter = false;
  if (!to.query.domain && from.query.domain) {
    to.query.domain = query.domain;
    resetRouter = true;
  }
  if (!to.query.username && from.query.username) {
    to.query.username = query.username;
    resetRouter = true;
  }

  if (!to.query.themeType && from.query.themeType) {
    to.query.themeType = query.themeType;
    resetRouter = true;
  }

  if (resetRouter) {
    router.push({
      path: to.path,
      query: to.query
    });
    return;
  }
  next();
});
export default router;
